<template>
  <div>
    <el-dialog title="" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <div>
        <table id="tag" class="table" ref="print" cellspacing="2" cellpadding="2" border="1">
            <tr  style="height:15%;">
              <td colspan="2" style="padding-left:0px">
                <table cellspacing="0" style="border:0px; width:100%" cellpadding="0" border="0">
                  <tr style="border:0px;">
                    <td class="td2" style="padding-left:0px">
                       <table cellspacing="0" style="border:0px;" cellpadding="0" border="0">
                        <tr style="border:0px;">
                          <td style="border:0px;padding-left:0px">
                            <img src="static/sendCar.jpg" style="height:60px;margin:5px; ">
                          </td>
                          <td style="border:0px; font-size:20px;font-weight:bolder;padding-left:0px">
                            {{datas.sender}}
                          </td>
                        </tr>
                       </table>
                    </td>
                    <td class="td2" style="text-align: right;">
                      <br>
                      <br>
                      单号：{{datas.order_code}}
                      </td>
                  </tr>
                </table>
              </td>
          </tr>
           <tr  style="height:12%;">
            <td colspan="2" >
              <table cellspacing="0" style="border:0px; width:100%" cellpadding="0" border="0">
                  <tr style="border:0px;">
                    <td class="td2 fontBolder" >寄： {{sendCity}}</td>
                    <td class="td2 " style="  text-align: right; line-height: 30px;">
                    <!-- <i class="el-icon-phone"></i> -->
                    <img src="static/phone.png" style="height:17px; vertical-align:middle;">
                    {{datas.start_phone}}</td>
                  </tr>
                </table>
            </td>
          </tr>
          <tr style="height:12%;">
            <td colspan="2" class="fontBolder" >收：{{toCity}}</td>
            </tr>
          <tr  style="height:45%;">
            <td >
              <p class="tdP fontBolder" >名称：{{datas.item_type}}</p>
              <p class="tdP fontBolder" >体积：{{datas.volume}}m³</p>
              <p class="tdP fontBolder" >
                支付：
                <span v-if="datas.settlement_type==0">寄付现结</span>
                <span v-if="datas.settlement_type==1">货到付款</span>
                <span v-if="datas.settlement_type==2">月结</span>
              </p>
            </td>
            <td>
              <p class="tdP fontBolder" >数量：{{datas.goods_num}}件</p>
              <p class="tdP fontBolder" >重量：{{datas.weight}}kg</p>
              <p class="tdP fontBolder" >签收：</p>
            </td>
          </tr>
          <tr>
            <td colspan="2" >
              <span class="fontBolder">备注：</span>{{datas.remarks}}
            </td>
          </tr>
        </table>
        
        <!-- <table id="tag" class="table" ref="print" cellspacing="2" cellpadding="2" border="1">
          <tr>
            <th colspan="1" class="title">公司名称：</th>
            <th colspan="3">{{datas.end_owner_name}}</th>
          </tr>
          <tr>
            <th colspan="1" class="title">订单编号：</th>
            <th colspan="3">{{datas.order_code}}</th>
          </tr>
          <tr>
            <th colspan="4" class="big">
              {{datas.start_province}}
              <em><i class="el-icon-sort"></i></em>
              {{datas.end_province}}
            </th>
          </tr>
          <tr>
            <td class="title">货品名称：</td>
            <td>{{datas.item_type}}</td>
            <td class="title">数量：</td>
            <td>{{datas.goods_num}}件</td>
          </tr>
          <tr>
            <td class="title">体积：</td>
            <td>{{datas.volume}}m³</td>
            <td class="title">重量：</td>
            <td>{{datas.weight}}kg</td>
          </tr>
          <tr>
            <td class="title">支付：</td>
            <td>
              <span v-if="datas.settlement_type==0">寄付现结</span>
              <span v-if="datas.settlement_type==1">货到付款</span>
              <span v-if="datas.settlement_type==2">月结</span>
            </td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <th colspan="1" class="title">电话：</th>
            <th colspan="3">{{datas.end_phone}}</th>
          </tr>
          <tr class="full">
            <th colspan="1" class="title">备注：</th>
            <th colspan="3">{{datas.remarks}}</th>
          </tr>
        </table> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
        <el-button type="primary" @click="prints">打 印</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>

  export default {
    props:['datas'],
    data() {
      return {
        dialogVisible: false,
        sendCity:"",
        toCity:"",
        from: {

        }
      }
    },

    methods: {
      open(id) {
        this.from.id = id;
        this.dialogVisible = true;
        var send = this.datas.start.split("市");
        this.sendCity = send[0]+"市";
        var to = this.datas.end.split("市");
        this.toCity = to[0]+"市";

      },
      handleClose(done) {
          this.dialogVisible = false;
       /* this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {}); */
      },
      prints(){
        this.$print(this.$refs.print) // 使用
          // this.$print(this.$refs.print) // 使用
          this.dialogVisible = false;
      }
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped lang='less'>
@media print {
    @page {
      size:  21cm 29.7cm;
      margin: 0;
      padding: 0;
    }

    .noprint {
      display: none;
    }
  }

#tag tr,td,th{

  border: 2px solid #000;
  text-align: center;
  padding: 0px 10px;
}
/* #tag tr,td,th{
  border: 2px solid #000;
  text-align: center;
} */

.table{
  margin: auto;
  width: 400px;
  height: 466px;
  // width: 60mm;
  // height: 70mm;
}
.table td{
  text-align: left;
}
.tdP{
  padding-bottom: 20px;
  padding-top: 10px;
}
.td2{
  border: 0px solid #000;
  text-align: center;
  padding: 0px;
}
.title{
  width: 120px;
  font-weight: 500;
  font-size: 16px;
  text-align: right;
  width: 100px;
}

.fontBolder{
  font-size:20px;
  font-weight:bolder;
}


/* .table{
  padding: 20px;
  width: auto;
  text-align: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-bottom: 50px;
}
.table {
  border-collapse: collapse;
  border-spacing: 0;
} */
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/components/orderPrint.vue